import { render, staticRenderFns } from "./FinancialSetup.vue?vue&type=template&id=1b40b399&scoped=true&"
import script from "./FinancialSetup.vue?vue&type=script&lang=js&"
export * from "./FinancialSetup.vue?vue&type=script&lang=js&"
import style0 from "./FinancialSetup.vue?vue&type=style&index=0&id=1b40b399&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b40b399",
  null
  
)

export default component.exports